
import { useLocation, useParams } from 'react-router-dom';
import FormService from '../../core/services/FormService';
import { useContext, useState } from 'react';
import { AppEventContext, FormSubmissionContext } from '../../App';
import { FORM_REVIEW_APPROVED_EVENT, FORM_REVIEW_REJECTED_EVENT, FormReviewStatus, FormStatus } from '../../core/constants/common';
import { toast } from 'react-toastify';
import ConfirmationModal from '../ConfirmationModal/ConfirmationModal';
import Utils from '../../core/utilities/Utils';

export const FormNavbarActions = ({ }) => {

	const currentURL = window.location.href;

	const { formSubmissionData, setFormSubmissionData } = useContext(FormSubmissionContext);
	const { setAppEventData } = useContext(AppEventContext);
	const [actionMade, setActionMade] = useState('');
	const location = useLocation();

	const isReview = location.pathname.includes('/review');
	const isOpenForm = location.pathname.includes('/open-form/');
	const token = location.pathname.substring(location.pathname.lastIndexOf('/review/') + 8, location.pathname.length);

	const onApproveSubmission = () => {
		FormService.approveSubmission(token)
			.then(res => {
				if (res.status !== 200) return;

				toast.success("Success", {
					position: toast.POSITION.TOP_RIGHT,
				});
				if (isOpenForm) {
					setAppEventData({ name: FORM_REVIEW_APPROVED_EVENT });
				} else {
					const url = Utils.getFormattedFormBuilderExitURL();
					if (!url) return;
					window.location.href = url;
				}
			}).catch(err => { });
	};

	const onRejectSubmission = () => {
		FormService.rejectSubmission(token)
			.then(res => {
				if (res.status !== 200) return;

				toast.success("Success", {
					position: toast.POSITION.TOP_RIGHT,
				});
				if (isOpenForm) {
					setAppEventData({ name: FORM_REVIEW_REJECTED_EVENT });
				} else {
					const url = Utils.getFormattedFormBuilderExitURL();
					if (!url) return;
					window.location.href = url;
				}
			}).catch(err => { });
	};

	const onConfirmation = (confirmed) => {
		setActionMade('');
		if (!confirmed) return;

		if (actionMade === 'APPROVE') {
			onApproveSubmission();
		} else {
			onRejectSubmission()
		}
	};

	return (
		<>
			{
				isReview &&
				formSubmissionData.status === FormStatus.PENDING_APPROVAL &&
				formSubmissionData.formReviewRequest?.status === FormReviewStatus.PENDING &&
				<button type="button"
					className="btn btn-primary text-white"
					onClick={() => setActionMade('APPROVE')}>Approve</button>
			}
			{
				isReview &&
				formSubmissionData.status === FormStatus.PENDING_APPROVAL &&
				formSubmissionData.formReviewRequest?.status === FormReviewStatus.PENDING &&
				<button type="button"
					className="btn btn-primary text-white"
					onClick={() => setActionMade('REJECT')}>Send back for correction</button>
			}
			{
				(actionMade === 'APPROVE' || actionMade === 'REJECT') &&
				<ConfirmationModal
					modalShow={true}
					messageText={'Please confirm if the review is completed and necessary comments added in reviewed questions'}
					callbackModal={(confirmed) => onConfirmation(confirmed)}
				/>
			}
		</>
	);
};

export default FormNavbarActions;



